module.exports = __webpack_public_path__ + "static/media/webpage.fb52c2a2.mov";